import { Link } from "react-router-dom";
import { ImExit } from "react-icons/im";
import { IoSettingsSharp } from "react-icons/io5";

export default function Sidebar({
    sidebarOpen,
    sidebarItems,
    activeIndex,
    handleItemClick,
    handleLogoutClick,
    handlesetting,
    t,
}) {
    return (
        <aside
            id="logo-sidebar"
            className={`fixed top-0 left-0 z-40 w-[300px] h-screen pt-20 transition-all duration-300 
      bg-gradient-to-b from-[#3686FF] to-[#2267D1] shadow-lg border-r border-white/10
      ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} sm:translate-x-0`}
            aria-label="Sidebar"
        >
            <div className="h-full flex flex-col justify-between px-6 pt-10 pb-5 overflow-y-auto">
                {/* Sidebar Menu */}
                <ul className="space-y-2 font-medium">
                    {sidebarItems.map((item, index) => {
                        const isActive = activeIndex === index;
                        return (
                            <li key={index}>
                                <Link
                                    to={item.path}
                                    onClick={() => handleItemClick(index)}
                                    className={`flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-300 group
                    ${isActive
                                            ? "bg-white text-[#3686FF] shadow-md"
                                            : "text-white hover:bg-white/20 hover:shadow-md"
                                        }
                  `}
                                >
                                    <span
                                        className={`text-xl transition-colors ${isActive ? "text-[#3686FF]" : "text-white group-hover:text-white"
                                            }`}
                                    >
                                        {item.icon}
                                    </span>
                                    <span className="text-[15px] font-medium">{item.name}</span>
                                </Link>
                            </li>
                        );
                    })}
                </ul>

                {/* Bottom Section */}
                <div className="pt-1 border-t border-white/20">
                    <div className="flex items-center justify-between mt-4">
                        {/* Logout */}
                        <button
                            onClick={handleLogoutClick}
                            className="flex items-center gap-3 text-white hover:text-[#f6f6f6] transition-colors"
                        >
                            <ImExit size={22} />
                            <span className="text-[15px]">{t("logOut")}</span>
                        </button>

                        {/* Settings */}
                        <span
                            onClick={handlesetting}
                            className="p-2 rounded-lg hover:bg-white/20 transition-all cursor-pointer"
                        >
                            <IoSettingsSharp size={22} className="text-white" />
                        </span>
                    </div>
                </div>
            </div>
        </aside>
    );
}
